import React, { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Contact from "./components/Contact";
import Dashboard from "./components/dashboard/Dashboard.js";
import Home from "./components/Home";
import SsoRedirect from "./components/SsoRedirect.js";
import Layout from "./components/Layout";
import Tickets from "./components/ticket/Tickets.js";
import TicketTab from "./components/ticket/TicketTab";
/* The following line can be included in your src/index.js or App.js file */
import { Navigate } from "react-router-dom";
import "./App.scss";
import { getHighestRole, isAuthenticated } from "./auth/authService.js";
import { handleSSOCallback } from "./auth/ssoUtils.js";
import Unauthorized from "./auth/Unauthorized.js";
import Admin from "./components/administration/Admin.js";
import Impact from "./components/administration/Impact/Impact.js";
import Users from "./components/administration/Org/Users.js";
import Priority from "./components/administration/Priority/Priority.js";
import RequestType from "./components/administration/RequestType/RequestType.js";
import Resolver from "./components/administration/Resolver/Resolver.js";
import ResolverGroup from "./components/administration/ResolverGroup/ResolverGroup.js";
import Roles from "./components/administration/Roles/Roles.js";
import Urgency from "./components/administration/Urgency/Urgency.js";
import AssetMenu from "./components/Asset/AssetMenu.js";
import Login from "./components/login/Login.js";
import ReportTab from "./components/reports/ReportTab.js";
import TaskTab from "./components/task/TaskTab.js";
import SolutionMenu from "./components/solutions/SolutionMenu.js";
import SystemValues from "./components/system_values/SystemValues.js";
import Tasks from "./components/task/Tasks.js";
import AboutPage from "./components/v2/home/About";
import EmailQueue from "./components/queue/EmailQueue.js";
import Configuration from "./components/system_values/Configuration.js";
import { ROUTES } from "./Constants/Constants";
import {
  DASHBOARD,
  HOME,
  SETTINGS,
  SOLUTIONS,
  TICKETS,
  REPORTS,
  TASK,
  QUEUE,
  CHANGE,
  CI
} from "./Constants/RolesConstants.js";
import ProtectedRoute from "./ProtectedRoute.js";
import ConfigurationItem from "./components/Configuration_Items/ConfigurationItem.js";
import Changes from "./components/change/Changes.js";

export const AuthContext = createContext(null);
class App extends React.Component {
  constructor(props) {
    super(props);
    handleSSOCallback();
    this.state = {
      isUserAuthenticated: isAuthenticated(),
      userRole: getHighestRole(),
    };
  }
  componentDidMount() {
    this.updateAuthStatus();
  }

  updateAuthStatus = () => {
    this.setState({
      isUserAuthenticated: isAuthenticated(),
      userRole: getHighestRole(),
    });
  };
  render() {
    const { isUserAuthenticated, userRole } = this.state;
    const authContextValue = {
      isUserAuthenticated,
      userRole,
      updateAuthStatus: this.updateAuthStatus,
    };
    return (
      <AuthContext.Provider value={authContextValue}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/sso-redirect" element={<SsoRedirect />} />
          <Route element={<Layout />}>
            <Route
              path={ROUTES.DASHBOARD}
              element={
                <ProtectedRoute
                  componentName={DASHBOARD}
                  Component={Dashboard}
                ></ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.HOME}
              element={
                <ProtectedRoute
                  componentName={HOME}
                  Component={Home}
                ></ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.TICKETS}
              element={
                <ProtectedRoute
                  componentName={TICKETS}
                  Component={Tickets}
                ></ProtectedRoute>
              }
            />
            {/* <Route path="/editTicket/:viewTicketId" element={<TicketTab />} /> */}
            <Route
              path={ROUTES.EDIT_TICKET}
              element={
                <ProtectedRoute
                  componentName={TICKETS}
                  Component={TicketTab}
                ></ProtectedRoute>
              }
            />

            <Route path={ROUTES.CONTACT} element={<Contact />} />
            <Route path={ROUTES.ADMIN} element={<Admin />} />
            <Route
              path={ROUTES.SETTINGS}
              element={
                <ProtectedRoute
                  componentName={SETTINGS}
                  Component={SystemValues}
                ></ProtectedRoute>
              }
            />
            <Route path={ROUTES.ASSETS} element={<AssetMenu />} />
            <Route path={ROUTES.CI} element={<ConfigurationItem />} />
            <Route
              path={ROUTES.SOLUTIONS}
              element={
                <ProtectedRoute
                  componentName={SOLUTIONS}
                  Component={SolutionMenu}
                ></ProtectedRoute>
              }
            />
            <Route path={ROUTES.QUEUE}
              element={
                <ProtectedRoute
                  componentName={QUEUE}
                  Component={EmailQueue}
                ></ProtectedRoute>
              }
            />
            <Route path={ROUTES.USERS} element={<Users />} />
            <Route path={ROUTES.ROLES} element={<Roles />} />
            <Route path={ROUTES.REQUEST_TYPES} element={<RequestType />} />
            <Route path={ROUTES.URGENCY} element={<Urgency />} />
            <Route path={ROUTES.IMPACT} element={<Impact />} />
            <Route path={ROUTES.PRIORITY} element={<Priority />} />
            <Route path={ROUTES.RESOLVER_GROUPS} element={<ResolverGroup />} />
            <Route path={ROUTES.RESOLVER} element={<Resolver />} />
            <Route path={ROUTES.UNAUTHORIZED} element={<Unauthorized />} />
            <Route path={ROUTES.CHANGE} element={<Changes />} />
            <Route path={ROUTES.REPORTS}
              element={
                <ProtectedRoute
                  componentName={REPORTS}
                  Component={ReportTab}
                ></ProtectedRoute>
              } />
            <Route path={ROUTES.ABOUT} element={<AboutPage />} />
            <Route path={ROUTES.TASKS}
              element={
                <ProtectedRoute
                  componentName={TASK}
                  Component={TaskTab}
                ></ProtectedRoute>
              }
            />
          </Route>

          {/* </Route> */}
          {/* <Route path='/signup' element={ <SignUp /> }/>                         */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthContext.Provider>
    );
  }
}

export default App;
